import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-campaign-manager-details',
  templateUrl: './help-google-campaign-manager-details.component.html'
})
export class HelpGoogleCampaignManagerDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
